<div class="flex flex-column align-items-center">
  <div class="font-bold text-xl mb-2">OTP Verification</div>
  <p class="text-color-secondary block mb-5">
    Please enter the code sent to your email.<br />If you don’t see it, check
    your spam or junk folder. <br />Delivery may take up to 2 minutes.
  </p>
  <p-inputOtp
    #otpInput
    [autofocus]="true"
    [integerOnly]="true"
    [length]="6"
    [(ngModel)]="otpCode"
    [disabled]="showError || !isResendCodeDisabled"
    (paste)="verifyOtpCode()"
  />
</div>
@if (showError) {
  <div class="error pt-2">
    <span class="icon icon-cx-error-circle-filled"></span>
    <span>
      {{ errorMessage }}
    </span>
  </div>
}

@if (enableRecaptchaFlag && !useTurnstile && !isResendCodeDisabled) {
  <div class="ml-4 mt-2">
    <div auRecaptcha (recaptchaSuccess)="resolved($event)"></div>
  </div>
}

@if (useTurnstile) {
  <div
    #turnstileRef
    class="turnstile-container flex justify-content-center mt-3"
  ></div>
}

<div class="flex justify-content-between mt-5 align-self-stretch">
  <button
    type="button"
    pButton
    pRipple
    class="p-button-secondary"
    (click)="requestOtpCode()"
    [disabled]="
      isResendCodeDisabled ||
      (enableRecaptchaFlag && !useTurnstile && !newRecaptchaResponse)
    "
  >
    <span pButtonLabel>{{
      'Resend Code' + (countdown > 0 ? ' (' + countdown + 's)' : '')
    }}</span>
  </button>
  <button
    type="button"
    pButton
    pRipple
    (click)="verifyOtpCode()"
    [disabled]="otpCode.length !== 6 || !isResendCodeDisabled"
  >
    <span pButtonLabel>Submit Code</span>
  </button>
</div>
